/* src/app/modules/members/member-picture/member-picture.component.scss */
.member-picture {
  border-radius: 100%;
  overflow: hidden;
  height: 100%;
  width: 100%;
  margin: 0 auto;
}
.member-picture.square {
  border-radius: 0;
}
.member-picture img {
  height: 100%;
  width: 100%;
}
/*# sourceMappingURL=member-picture.component.css.map */
